import React from 'react';

function CompanyIcon({ color = '#000', opacity }) {
  return (
    <svg
      style={{ display: 'block' }}
      xmlns="http://www.w3.org/2000/svg"
      width="31.712"
      height="20.169"
      viewBox="0 0 31.712 20.169"
    >
      <g data-name="picto-compte entreprise" transform="translate(.6 .6)">
        <g data-name="Groupe 1821">
          <g data-name="Groupe 2061">
            <path
              fill="none"
              stroke={color}
              strokeMiterlimit="10"
              strokeWidth="1.2"
              d="M12.072 18.962H0V0h3.613v10.436l5.338-4.029a.43.43 0 01.691.334l.04 3.993h.194l5.411-4.085a.632.632 0 011.014.491l.017 2.576"
              data-name="Tracé 262"
            />
          </g>
        </g>
        <g data-name="Groupe 1823" transform="translate(14.072 1.746)">
          <g fill="none" stroke={color} strokeMiterlimit="10" strokeWidth="1.2" data-name="Groupe 2060">
            <path
              d="M16.368 17.223a15.331 15.331 0 00-1.779-5.862 5.311 5.311 0 00-1.773-1.8c-1.775-1.1-7.533-.963-9.266 0a6.066 6.066 0 00-2.53 3.411 24.366 24.366 0 00-1.019 4.253zM11.404 3.162A3.194 3.194 0 118.213 0a3.178 3.178 0 013.191 3.162z"
              data-name="Tracé 263"
            />
            <path d="M0 4.388L0 0" data-name="Ligne 290" transform="translate(4.927 12.956)" />
            <path d="M0 4.388L0 0" data-name="Ligne 291" transform="translate(11.406 12.956)" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default CompanyIcon;
